import {useMemo} from 'react';
import {Option} from '../../../role-autocomplete/autocomplete-input';
import {FetchEntityUsersResult} from '../../../../hooks/use-fetch-entity-users';
import {AffiliatedUser} from '../../../../backend/responses/affiliated-user';
import {BaseUsersInput} from '../../../users-input/users-input';

type CareServicesUserInputProps = {
  usersData: FetchEntityUsersResult;
  defaultOptionLabel?: string;
  onChange?: (user: AffiliatedUser | undefined) => void;
};

export function CareServicesUserInput(props: CareServicesUserInputProps) {
  const options = useMemo(() => {
    if (!props.usersData.items) return [];

    return props.usersData.items.reduce<Option[]>((acc, {user}) => {
      const u = {
        key: user.id!,
        label: user.displayName || user.name,
        picture: user.picture || '',
      };
      acc.push(u);

      return acc;
    }, []);
  }, [props.usersData.items]);

  return (
    <BaseUsersInput
      options={options}
      loading={props.usersData.isLoading}
      defaultOptionLabel={props.defaultOptionLabel}
      onChange={(userId) => {
        const user = props.usersData.items?.find(({user}) => user.id === userId);
        props.onChange?.(user);
      }}
    />
  );
}
